import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage16.module.css"
import BlockData from "../../../layman-explanation-json/hecate.json";
import Common_html from './Common_html';
export default function LaymanPage16() {
  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  )
}
